// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": function componentCacheCachesGatsbyPluginOfflineAppShellJs() {
    return import("./../../.cache/caches/gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-ts": function componentSrcPages404Ts() {
    return import("./../../src/pages/404.ts"
    /* webpackChunkName: "component---src-pages-404-ts" */
    );
  },
  "component---src-pages-blogtemplate-ts": function componentSrcPagesBlogtemplateTs() {
    return import("./../../src/pages/blogtemplate.ts"
    /* webpackChunkName: "component---src-pages-blogtemplate-ts" */
    );
  },
  "component---src-pages-brand-ts": function componentSrcPagesBrandTs() {
    return import("./../../src/pages/brand.ts"
    /* webpackChunkName: "component---src-pages-brand-ts" */
    );
  },
  "component---src-pages-tags-ts": function componentSrcPagesTagsTs() {
    return import("./../../src/pages/tags.ts"
    /* webpackChunkName: "component---src-pages-tags-ts" */
    );
  },
  "component---src-templates-author-bio-ts": function componentSrcTemplatesAuthorBioTs() {
    return import("./../../src/templates/author-bio.ts"
    /* webpackChunkName: "component---src-templates-author-bio-ts" */
    );
  },
  "component---src-templates-blog-list-ts": function componentSrcTemplatesBlogListTs() {
    return import("./../../src/templates/blog-list.ts"
    /* webpackChunkName: "component---src-templates-blog-list-ts" */
    );
  },
  "component---src-templates-blog-post-ts": function componentSrcTemplatesBlogPostTs() {
    return import("./../../src/templates/blog-post.ts"
    /* webpackChunkName: "component---src-templates-blog-post-ts" */
    );
  },
  "component---src-templates-tag-list-ts": function componentSrcTemplatesTagListTs() {
    return import("./../../src/templates/tag-list.ts"
    /* webpackChunkName: "component---src-templates-tag-list-ts" */
    );
  }
};